import { createReducer, on } from '@ngrx/store';
import { menuItems } from '@shared/constants/menu-items';
import { MenuItem } from '@shared/models/interfaces/menu-item.interface';
import { loadMenuItems, updateMenuItems } from '@store/actions/menu-items.actions';

export const initialState: MenuItem[] = menuItems;

export const menuItemsReducer = createReducer(
    initialState,
    on(loadMenuItems, (state) => {
        return {
            ...state,
        };
    }),
    on(updateMenuItems, (state, action) => {
        const items = [
            ...state.map((item) => {
                return {
                    ...item,
                    active: false,
                };
            }),
        ];
        const menuItems = items.map((item) => {
            if (item.name.toLowerCase() === action.menuItem.name.toLowerCase()) {
                return {
                    ...item,
                    active: action.firsLevelNavigation,
                };
            }
            return { ...item };
        });
        return [...menuItems];
    })
);
